import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Star } from 'lucide-react';

export default function CreatorSpotlightSystem() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Creator Spotlight System</h1>
        <p className="text-[#8A93A6]">Featured creators, highlights, and community showcases</p>
      </div>
      <Card className="glass">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2 text-white">
            <Star className="h-5 w-5 text-yellow-500" />
            Spotlight Management
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-[#8A93A6]">Featured creator management, spotlight scheduling, and community showcases will be configured here.</p>
        </CardContent>
      </Card>
    </div>
  );
}
